<template>
<div id="activo_fijo" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="REPORTES DE ABONOS - REFERENCIA PEDIMENTOS" class="elevation-1 px-5 py-3" >
          <br>

              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-subtitle v-if="model.tipo_reporte == 1">
                    <small class="red--text">*Los campos de “FECHA” requeridos para este módulo, se refieren a un periodo definido por rango (ejemplo: del 01-enero-2015 al 31-diciembre-2018).</small>
                  </v-card-subtitle>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                      <v-col sm="6" md="6" lg="6">
                        <v-autocomplete v-model="model.tipo_reporte" :items="tipos"
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id"
                          label="Filtrar Por" @change="clear_values()" :rules="[rules.required]" >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="3" sm="3" lg="3">
                        <v-autocomplete v-model="model.clave_destino" :items="destinos"
                          :hide-no-data="true" :return-object="false" item-text="text" item-value="id"
                          label="Clave de Retorno">
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row v-if="model.tipo_reporte == 2" row wrap>
                      <v-col cols="6" >
                        <v-combobox v-model="lista_filtrada" label="Lista de Folios" multiple persistent-hint small-chips disabled color="green">
                        </v-combobox>
                      </v-col>
                      <v-col cols="2" >
                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                          <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                      <v-row v-if="model.tipo_reporte == 1" row wrap>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu1 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="6" lg="6" >
                          <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu2 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                      </v-row>

                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs(0)" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargarReportes" />
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

  <v-dialog v-model="dialog1" max-width="500px" >
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de Folios</h5>
        <span>Uno por línea</span>
        <v-form ref="formListado" lazy-validation="" >
          <v-textarea outlined rows="15" v-model="listado" :rules="[validaListado]" ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="listado=''; lista_filtrada=[]; dialog1 = false" >Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.getDestinos();
    this.URL = this.$hostname + "reportes_ws/";
    this.loading = false;
    this.rfc = this.$local_storage.get("rfc");
    this.tipo = 1;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    this.cargarReportes();
  },
  computed: {
  },
  data: () => ({
    destinos:[],
    listado:"",
    dialog1:false,
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Reportes",
        disabled: true,
        to: ""
      },
      {
        text: "Abonos",
        disabled: true,
        to: ""
      },
      {
        text: "Referencia Pedimentos",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: [],
      reportesPartidas: [],
      reportesDescargos: [],
    },
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    show_loading: true,
    tipos: [{
        "id": 1,
        "text": "Por Fechas de Validación Informe"
      }, {
        "id": 2,
        "text": "Por Folio | Listado de Folios"
      },
    ],
    model: {
      rfc: "",
      usuario: "",
      folio: "",
      fecha_de: "",
      fecha_a: "",
      reporte_url: "/soluciona31/reportes/rpt_abonos_referencia_pedimentos/",
      nombre_reporte: "Abonos Referencia Pedimentos",
      tipo: "SA31_Abonos_Referencia_Pedimento",
      opc_impo: 1,
      opc_expo: 1,
      opc_descripcion: 1,
      tipo_reporte: 1,
      clave_destino:""

    },

    selecciona_todo8: false,
    selecciona_todo8_partida: false,
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    lista_filtrada: [],
  }),
  methods: {
    setListValues: function() {
      this.lista_filtrada = [];
      let to_list = this.get_array_lista(this.listado);
      for (var i = 0; i < to_list.length; i++) {
        if (this.lista_filtrada.includes(to_list[i])) {
          continue;
        } else {
          this.lista_filtrada.push(to_list[i]);
        }
      }
      this.model.fecha_de = "";
      this.model.fecha_a = "";
      this.dialog1 = !this.dialog1;
    },
    get_array_lista: function(cadena) {
      try {
        var newarr = [];
        if (cadena != undefined) {
          let data = cadena.split("\n");
          newarr = data.filter(a => a.trim() !== '');
          for (var i = 0; i < newarr.length; i++) {
            newarr[i] = newarr[i].trim();
            newarr[i] = newarr[i].replace(',', '');
            newarr[i] = newarr[i].replace('.', '');
          }
        }
        return newarr;
      } catch (error) {
        console.log(error);
      }
    },
    getDestinos: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
       var data = {
           "rfc": this.$local_storage.get("rfc")
       };

       axios({
           method: "post",
           url: this.$apiSA31 + "soluciona31/reportes/get_destinos_cliente/",
           data: data
         })
         .then(response => {
               if(response.data && response.data.length){
                   this.destinos = response.data
               } else {
                   this.destinos = [];
               }
         }).catch(error => {
           this.$swal({
             type: "error",
             title: "¡Operación no Permitida!",
             text: "Ocurrió un error al obtener los destinos. Intente nuevamente.",
             footer: ""
           });
         }).then(() => {
           this.$root.$dialogLoader.hide();
         });
    },
    clear_values() {
      this.model.folio = '';
      this.model.fecha_de = '';
      this.model.fecha_a = '';
      this.listado = "";
    },
    validaPedimento: function() {
      if (this.model.pedimento != "") {
        if (!this.validarPatronPedimento(this.model.pedimento))
          return "Pedimento no válido. Ejemplo: 240-0123-0000123";
      }
      return true;
    },
    validarPatronPedimento(pedimento) {
      const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
      return patternPedimento.test(pedimento);
    },
    validaListado: function() {
      var listadoSinEspacios = this.removerLineasVacias(this.listado);
      if (listadoSinEspacios.length == 0) {
        return "Ingrese al menos 1 folio. Favor de verificar.";
      } else if (listadoSinEspacios.length > 250) {
        return "No se puede consultar mas de 250 folios";
      }
      return true;
    },
    removerLineasVacias(listado) {
      var listadoSplit = this.listado.split("\n");
      var listadoSinEspacios = listadoSplit.filter(item => {
        return item.trim() != "";
      });
      return listadoSinEspacios;
    },
    generaReporteListado() {
      if (this.$refs.formListado.validate() && this.model.nombre_reporte!="") {
        this.generar_reporte_sqs(1);
        this.dialog1 = false;
      }
    },
    verificaTipoOperacion: function() {
      if (this.model.opc_impo != 1 && this.model.opc_expo != 1) {
        return "Seleccione al menos un tipo de operación";
      }
      return true;
    },

    setNombreReporte: function () {
        var url = this.model.reporte_url
        var search = this.list_reportes.filter(function (e) {
            return e.url == url;
        });
        if (search.length > 0) {
            this.model.nombre_reporte = search[0].reporte;
        }
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    generar_reporte_sqs() {

      if (this.model.tipo_reporte == 2 && this.lista_filtrada.length == 0) {
        this.$swal({
            type: "info",
            title: "¡Operación no Permitida!",
            text: "Debe agregar al menos 1 folio.",
            footer: ""
          });
      } else if (this.model.tipo_reporte == 1 && !this.$refs.form.validate()) {
        
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;

        if(this.model.tipo_reporte == 2){//Busqueda por listado
          data["lista"] = this.removerLineasVacias(this.listado);
          data.folio = '';
        }
        if (data.folio == '') delete(data['folio']);
        if (data.fecha_de == '') delete(data['fecha_de']);
        if (data.fecha_a == '') delete(data['fecha_a']);

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "SA31_Abonos_Referencia_Pedimento"
      };
      axios.post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          if(params.fecha_de && params.fecha_de!="")
            return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
          else if(params.lista && params.lista.length)
            return "Búsqueda por listado";
          else if(params.folio && params.folio!="")
            return "Folio: "+params.folio;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control{
    margin-bottom: -35px;
}
.elevation-1 >>> .v-input--has-state > div:nth-child(1) > div:nth-child(2){
    margin-top: -10px;
}
.elevation-1 >>> div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light{
    font-size: 10px !important;
}
.v-card__text  >>> .columnadescripcion {
  white-space: normal !important;
  max-width: 300px !important;
}
.v-card__text  >>> .columnaidentificadores  {
  white-space: normal !important;
  max-width: 450px !important;
}
</style>
